export default __webpack_public_path__ + "static/media/IconGreenEnergy.fd26daa3.svg";